export const GET_USER_BADGE_START = 'GET_USER_BADGE_START';
export const GET_USER_BADGE_SUCCESS = 'GET_USER_BADGE_SUCCESS';
export const GET_USER_BADGE_FAIL = 'GET_USER_BADGE_FAIL';
